import { render, staticRenderFns } from "./NotFoundTwo.vue?vue&type=template&id=1842fc70"
import script from "./NotFoundTwo.vue?vue&type=script&lang=js"
export * from "./NotFoundTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports